"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = exports.Button = exports.ButtonIcon = exports.CardRightText = exports.CardTitleText = exports.CardLeftText = exports.Card = exports.HeaderContainer = void 0;
const native_1 = __importDefault(require("styled-components/native"));
exports.HeaderContainer = native_1.default.View `
  flex-direction: column;
  justify-content: space-between;
  z-index: 2;
`;
exports.Card = native_1.default.View `
  height: 40px;
  flex-direction: row;
  background-color: ${(p) => p.transparent ? 'transparent' : p.theme.header.background};
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  z-index: 2;
`;
exports.CardLeftText = native_1.default.Text `
  font-size: 16px;
  align-self: center;
  padding-right: 10px;
  padding-left: 10px;
`;
exports.CardTitleText = native_1.default.Text `
  font-size: 16px;
  line-height: 24px;
  align-self: center;
  padding-right: 10px;
  padding-left: 10px;
  color: ${(p) => p.transparent ? p.theme.text.color.white : p.theme.text.color.primary};
`;
exports.CardRightText = native_1.default.Text `
  font-size: 16px;
  align-self: center;
  padding-right: 10px;
  padding-left: 10px;
  color: ${(p) => p.theme.color.state.error};
`;
exports.ButtonIcon = native_1.default.TouchableOpacity `
  width: 44px;
  height: 100%;
  justify-content: center;
`;
exports.Button = native_1.default.TouchableOpacity `
  min-width: 44px;
`;
exports.Container = native_1.default.View `
  width: 100%;
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
  border-bottom-color: #dddddd;
  border-bottom-width: 1px;
  background-color: ${(p) => p.theme.color.white};
  padding: 16px 32px 24px 32px;
  shadow-color: ${(p) => p.theme.shadow.default.color};
  shadow-offset: 0px 4px;
  shadow-opacity: ${(p) => p.theme.shadow.default.opacity};
  shadow-radius: 4px;
  elevation: ${(p) => p.theme.shadow.default.elevation};
  z-index: 1;
`;
